import React from 'react';

export const LazyAdmin = React.lazy<typeof import('../Admin').Admin>(() =>
  import('../Admin').then((module) => ({ default: module.Admin })),
);
